module.exports = __webpack_public_path__ + "static/media/terminal_selection_origin_title_icon.17d7bf74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/bubble/images/terminal_selection_origin_title_icon.svg
// module id = 646
// module chunks = 0